/**
 * The base view for all modals. Defines basic functions such as opening and closing the dialog library.
 * All complex modals used in this application (ie not confirm dialogs) should extend this class
 * 
 * @example
 * UserDocs.View.Modal.MyModal = UserDocs.View.Modal.Base.extend({});
 *
 * @class
 */
UserDocs.View.Modal.Base = Backbone.View.extend(
/** @lends UserDocs.View.Modal.Base# */
{
	/** array of buttons to add to the document */
	buttons: [],
	
	/** an internal reference to the modal object created */
	modal : null,
	
	/** title for the modal window */
	title: "",
	
	/** template to use for help dialog */
	helpTemplate: null,
	
	/** width of the modal */
	width: 850,
	
	/** additional class to give to dialog */
	dialogClass: null,

	/** 
	 * Function called on object creation. Creates a modal using the jQuery UI Modal library extension
	 * created for ELE and located in common/js/ele.modal.js and stores a reference to it
	 */
	initialize: function() {
		var _this = this;
		var attributes = {};
		if (this.model) attributes = this.model.attributes;
		ele.modal.option('width', this.width);
        if(typeof this.recommendation != 'undefined'){
            attributes = this.recommendation;
        }
		this.modal = ele.modal.create({
			buttons: _this.buttons,
			content: this.$el.html(this.template(attributes)),
			close: function(){
				_this.close();
			},
			dialogClass: _this.dialogClass,
			title: _this.title,
			width: _this.width
		});
		if (this.helpTemplate) { 
			this.modal.siblings('.ui-dialog-titlebar').append(_.template($('#modal_template_help_icon').html()));
			this.modal.siblings('.ui-dialog-titlebar').find('.docHelp').on('click', function(){
				_this.help();
			})
		}
	},
	
	/** render the modal by calling 'open' on the dialog */
	render: function() {
		this.resize();
		this.modal.dialog("open");
	},
	
	/** close the modal and then removing this object from memory */
	close: function() {
		if (this.modal != null) {
			this.modal.dialog('close');
			this.remove();
		}
	}, 
	
	/** hide the title bar and close button so modal cannot be hidden without call to action */
	hideTitle: function() {
		this.modal.closest(".ui-dialog").find(".ui-dialog-titlebar").hide();
	},
	
	/**
	 * resize and reposition modal as it doesn't do it automatically  
	 * usually called when loading in new data
	 */
	resize: function(){
		ele.modal.resize(this.modal);
	},
	
	/** launch a help modal using the help template of the child Object */
	help: function() {
		var helpModal = new UserDocs.View.Modal.Help;
		helpModal.content = this.helpTemplate;
		helpModal.render();
	}
});